export default "__VITE_ASSET__BWstihSt__"